<template>
  <table class="table table-striped">
    <thead>
      <tr>
        <th>MIEMBRO</th>
        <th class="text-center"></th>
        <th class="text-center">TIPO DE EQUIPO</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(item, index) in inputs" :key="index">
        <td>{{ item.user.first_name }} {{ item.user.last_name }}</td>
        <td class="text-center">
          <b v-if="item.coordinator" class="text-danger">Presidente</b>
        </td>
        <td class="text-center">
          {{
            item.type == "RT" ? "Revisor Técnico" : "Comisión de Acreditación"
          }}
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import * as actions from "../../../../apiURL";
import moment from "moment";
export default {
  mixins: [FormMixin],

  data() {
    return {
      preloader: false,
      inputs: {},
    };
  },

  created() {
    this.data();
  },

  methods: {
    data() {
      this.preloader = true;

      this.axiosGet(
        `${actions.TECHNICAL_REVIEWER}/commissionMembers/preliminaryReports?evalTestId=${this.$store.state.evaluatorReview.evalTestId}&currentInstance=true`
      )
        .then((res) => {
          if (res.status == 200) {
            this.inputs = res.data;
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.preloader = false;
        });
    },

    openTab(obj, fileName) {
      const w = window.open(obj[fileName].path, "_blank");
      w.focus();
    },

    formatDate(date) {
      return date ? moment(date).format("YYYY-MM-DD HH:mm:ss") : "";
    },
  },
};
</script>